import { PascalCase } from "type-fest";
import {pascalCase} from "./pascalCase";

export function enumOf<T extends Record<string, any>>(keys: Array<keyof T>): { [K in keyof T as PascalCase<K>]: K } {
    return keys.reduce((record, key) => ({
        ...record,
        [pascalCase(key as string)]: key
    }), {} as { [K in keyof T as PascalCase<K>]: K });
}
